import { render, staticRenderFns } from "./EmployerTemplate.vue?vue&type=template&id=4c0b5d18&"
import script from "./EmployerTemplate.vue?vue&type=script&lang=js&"
export * from "./EmployerTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports